import type { Reaction } from "@memento/types/reaction";
import type { ShareVideoAudience } from "@memento/types/share-video-audience";
import { GetAccessTokenFn } from "src/contexts/AuthProvider";
import { Fetcher } from "src/libs/fetcher";
import {
  getReactionSendEndpointUrl,
  getUpdateReactionEndpointUrl,
} from "./api-endpoint-lib";
import { VideoSource } from "./segment-lib";

type SendReactionProps = {
  cardId: string;
  cardUrl: string;
  emailSubject: string;
  emailBody: string;
  audience: ShareVideoAudience;
  getAccessToken: GetAccessTokenFn;
};

export const sendReaction = async ({
  getAccessToken,
  cardId,
  cardUrl,
  emailSubject,
  emailBody,
  audience,
}: SendReactionProps) => {
  const fetcher = Fetcher(getAccessToken);

  return fetcher(getReactionSendEndpointUrl(cardId, cardUrl), {
    method: "POST",
    body: {
      audience,
      emailSubject,
      emailBody,
    },
  });
};

type UpdateReactionIdentifier = {
  cardId: string;
  reactionId: string;
};

export const updateReaction = (
  getAccessToken: GetAccessTokenFn,
  { cardId, reactionId }: UpdateReactionIdentifier,
  reaction: Partial<Reaction>
) => {
  return Fetcher(getAccessToken)(
    getUpdateReactionEndpointUrl({ cardId, reactionId }),
    {
      method: "POST",
      body: reaction,
    }
  );
};

export function getReactionVideoSources(reaction: Reaction): VideoSource[] {
  return [
    {
      src: reaction.videoUrl.cdn,
      type: "video/mp4",
    },
    {
      src: reaction.videoUrl.s3,
      type: "video/mp4",
    },
  ];
}
